import React, { useState, useEffect, useMemo, useRef } from "react";
import { AlertCardDataRequired } from "../components/AlertCardDataRequired";
import { AlertDataRequiredInputs } from "../components/AlertDataRequiredInputs";
import { SettingChampionship } from "./SettingChampionship";
import { useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { ToastContainer } from "react-toastify";
import { useGroup } from "../context/groupContext";
import { useBets } from "../context/betsContext";
import { useAppContext } from "../context";

function FormCreateGroup() {
	const {
		getInfoActivesChampionships,
		infoActivesChampionships,
		loadingActivesChampionships,
		getInfoTypesOfBites,
		infoTypesOfBites,
		loadingTypesOfBites,
	} = useBets();

	const {
		loadingEditingGroup,
		editGroup,
		createGroup,
		loadingCreateNewGroup,
		getInfoGroupsSubscribed,
		infoGroupsUserSubscribed,
	} = useGroup();

	const { toastMessage, messageError } = useAppContext();

	const [defaultValueToForm, setDefaultValueToForm] = useState({
		name: "",
		fixtureBetTypeId: "",
		leagueIdentifiers: "",
		fixtureBetTypeIdDisplayName: "",
		leagueIdentifiersDisplayName: "",
		selectLimitedDateToChampionship: "",
		allowLeagueBets: false,
		championBetPoints: "",
		runnerUpBetPoints: "",
	});

	const [successfulTextToast, setsuccessfulTextToast] = useState("");

	const params = useParams();
	const isEditingGroup = Boolean(params.id);
	const getInfoGroupsSubscribedRef = useRef(getInfoGroupsSubscribed);
	const getInfoActivesChampionshipsRef = useRef(getInfoActivesChampionships);
	const getInfoTypesOfBitesRef = useRef(getInfoTypesOfBites);

	const alertRequiredDataDescription = {
		createGroup: "Por favor completar todos los campos, para crear el grupo",
		createGroupWithSetting:
			"Por favor completar la configuracion del pronostico de campeonato",
		settingNameGroup: "Falta rellenar nombre",
		selectingChampionship: "Falta seleccionar un campeonato",
		selectingTypeOfBeat: "Falta seleccionar el tipo de apuesta",
		settingDate: "Falta establecer una fecha limite",
		settingPointChampion: "Falta rellenar el pronostico del campeon",
		settingPointSubchampion: "Falta rellenar el pronostico del subcampeon",
	};

	const {
		register,
		formState: { errors },
		handleSubmit,
		reset,
		watch,
	} = useForm({
		defaultValues: defaultValueToForm,
	});

	const watchedValues = watch();
	const activeLeagueBets =
		watchedValues.allowLeagueBets === "true" || watchedValues.allowLeagueBets === true;

	const selectedChampionshipName = useMemo(() => {
		const selectedLeagueIdentifier = watchedValues?.leagueIdentifiers?.[0];
		const selectedLeague = infoActivesChampionships.Result?.find(
			(item) => item.uniqueIdentifier === selectedLeagueIdentifier
		);

		return (
			selectedLeague?.name ||
			defaultValueToForm.leagueIdentifiersDisplayName ||
			"Selecciona un campeonato"
		);
	}, [
		defaultValueToForm.leagueIdentifiersDisplayName,
		infoActivesChampionships.Result,
		watchedValues?.leagueIdentifiers,
	]);

	const selectedBetTypeName = useMemo(() => {
		const selectedBetType = infoTypesOfBites.Result?.find(
			(item) => String(item.id) === String(watchedValues.fixtureBetTypeId)
		);

		return (
			selectedBetType?.displayName ||
			defaultValueToForm.fixtureBetTypeIdDisplayName ||
			"Selecciona un tipo de apuesta"
		);
	}, [
		defaultValueToForm.fixtureBetTypeIdDisplayName,
		infoTypesOfBites.Result,
		watchedValues.fixtureBetTypeId,
	]);

	const handleOnChangeForm = (event) => {
		const { name, value, checked } = event.target;

		if (name === "allowLeagueBets") {
			setDefaultValueToForm((prev) => ({
				...prev,
				[name]: checked,
			}));
			return;
		}

		setDefaultValueToForm((prev) => ({
			...prev,
			[name]: value,
		}));
	};

	useEffect(() => {
		getInfoGroupsSubscribedRef.current = getInfoGroupsSubscribed;
	}, [getInfoGroupsSubscribed]);

	useEffect(() => {
		getInfoActivesChampionshipsRef.current = getInfoActivesChampionships;
	}, [getInfoActivesChampionships]);

	useEffect(() => {
		getInfoTypesOfBitesRef.current = getInfoTypesOfBites;
	}, [getInfoTypesOfBites]);

	useEffect(() => {
		getInfoGroupsSubscribedRef.current();
		getInfoActivesChampionshipsRef.current();
		getInfoTypesOfBitesRef.current();
	}, []);

	useEffect(() => {
		if (params.id && infoGroupsUserSubscribed.Result?.length > 0) {
			const group = infoGroupsUserSubscribed.Result.find(
				(item) => item.uniqueIdentifier === params.id
			);

			if (!group) {
				return;
			}

			const leagueIdentifiers = group.groupLeagues.map(
				(league) => league.league.uniqueIdentifier
			);
			const allowLeagueBets = group.groupLeagues.map(
				(league) => league.allowLeagueBets
			);
			const leagueBetDisplayName = group.groupLeagues.map(
				(league) => league.league.name
			);
			const leagueBetsDeadline = group.groupLeagues.map((league) =>
				league.groupLeagueSettings.map((setting) => setting.lockDate)
			);
			const leagueBetsPoints = group.groupLeagues.map((league) =>
				league.groupLeagueSettings.map((setting) => setting.points)
			);
			const pointsToChampion = leagueBetsPoints[0][0];
			const pointsToRunnerUp = leagueBetsPoints[0][1];
			const fixtureBetTypeId = group.fixtureBetTypeId;
			const fixtureBetTypeName = group.fixtureBetTypeName;

			const formatDeadline = (deadlineCollection) => {
				if (deadlineCollection[0].length > 0) {
					return deadlineCollection[0][0].split("T")[0];
				}

				return "";
			};

			reset({
				name: group.name,
				fixtureBetTypeId,
				selectLimitedDateToChampionship: formatDeadline(leagueBetsDeadline),
				allowLeagueBets: allowLeagueBets[0],
				championBetPoints: pointsToChampion,
				runnerUpBetPoints: pointsToRunnerUp,
				leagueIdentifiers: [leagueIdentifiers[0]],
			});

			setDefaultValueToForm((prev) => ({
				...prev,
				name: group.name,
				fixtureBetTypeId,
				fixtureBetTypeIdDisplayName: fixtureBetTypeName,
				leagueIdentifiersDisplayName: leagueBetDisplayName[0],
				leagueIdentifiers: leagueIdentifiers[0],
				allowLeagueBets: allowLeagueBets[0],
			}));
		}
	}, [infoGroupsUserSubscribed.Result, params.id, reset]);

	const checkingLocalStorage = localStorage.getItem("userApuestaco");

	useEffect(() => {
		if (!loadingEditingGroup && !loadingCreateNewGroup) {
			if (messageError) {
				toastMessage(messageError, "error");
				setsuccessfulTextToast("");
			} else if (successfulTextToast) {
				toastMessage(successfulTextToast, "info");
			}
		}
	}, [
		loadingCreateNewGroup,
		loadingEditingGroup,
		messageError,
		successfulTextToast,
		toastMessage,
	]);

	const onSubmit = (data) => {
		const allowLeagueBets =
			data.allowLeagueBets === "true" || data.allowLeagueBets === true;

		if (isEditingGroup) {
			const dataEditedGroup = {
				groupIdentifier: params.id,
				name: data.name,
				leagueIdentifiers: data.leagueIdentifiers,
				allowLeagueBets,
				leagueBetsDeadline: null,
				championBetPoints: null,
				runnerUpBetPoints: null,
			};

			if (allowLeagueBets && data.selectLimitedDateToChampionship) {
				const leagueBetsDeadline = new Date(
					data.selectLimitedDateToChampionship
				)?.toISOString();

				const dataEditedGroupFormated = {
					...dataEditedGroup,
					leagueBetsDeadline,
					championBetPoints: data.championBetPoints,
					runnerUpBetPoints: data.runnerUpBetPoints,
				};

				if (checkingLocalStorage) {
					editGroup(params.id, dataEditedGroupFormated);
					setsuccessfulTextToast("Se han guardado los cambios");
				} else {
					alert("necesitas iniciar sesion!");
				}
				return;
			}

			if (checkingLocalStorage) {
				editGroup(params.id, dataEditedGroup);
				setsuccessfulTextToast("Se han guardado los cambios");
			} else {
				alert("necesitas iniciar sesion!");
			}
			return;
		}

		const dataCreateNewGroup = {
			allowLeagueBets,
			fixtureBetTypeId: data.fixtureBetTypeId,
			leagueIdentifiers: data.leagueIdentifiers,
			name: data.name,
			championBetPoints: null,
			runnerUpBetPoints: null,
			selectLimitedDateToChampionship: data.selectLimitedDateToChampionship,
		};

		if (allowLeagueBets && data.selectLimitedDateToChampionship) {
			const dataFormated = {
				...dataCreateNewGroup,
				leagueBetsDeadline: new Date(
					data.selectLimitedDateToChampionship
				)?.toISOString(),
				championBetPoints: data.championBetPoints,
				runnerUpBetPoints: data.runnerUpBetPoints,
			};

			if (checkingLocalStorage) {
				createGroup(dataFormated);
				setsuccessfulTextToast("Se ha creado el grupo");
			} else {
				alert("necesitas iniciar sesion!");
			}
			return;
		}

		if (checkingLocalStorage) {
			createGroup(dataCreateNewGroup);
			setsuccessfulTextToast("Se ha creado el grupo");
		} else {
			alert("necesitas iniciar sesion!");
		}
	};

	return (
		<form onSubmit={handleSubmit(onSubmit)} className='group-form-layout'>
			{(messageError || successfulTextToast) && <ToastContainer limit={4} />}
			<div className='group-form-main'>
				<div className='group-form-header'>
					<p className='group-form-eyebrow mb-2'>
						{isEditingGroup ? "Editar grupo" : "Nuevo grupo"}
					</p>
					<h1 className='group-form-title mb-2'>
						{isEditingGroup
							? "Ajusta las reglas del grupo"
							: "Crea un grupo privado"}
					</h1>
					<p className='group-form-subtitle mb-0'>
						Define el campeonato, el tipo de apuesta y, si quieres, activa los
						pronosticos de campeonato con una configuracion simple.
					</p>
				</div>

				<section className='group-form-section'>
					<div className='group-form-section-head'>
						<h2 className='group-form-section-title'>Informacion basica</h2>
						<p className='group-form-section-copy mb-0'>
							Elige un nombre claro para que tus invitados reconozcan rapido el
							grupo.
						</p>
					</div>
					<div>
						<label htmlFor='nameGroup' className='form-label'>
							Nombre del grupo
						</label>
						<input
							value={defaultValueToForm.name}
							type='text'
							className='form-control group-form-input'
							id='nameGroup'
							placeholder='Ej. Amigos Liga 2026'
							{...register("name", {
								required: true,
								onChange: handleOnChangeForm,
							})}
						/>
						{errors.name?.type === "required" && (
							<AlertDataRequiredInputs>
								{alertRequiredDataDescription.settingNameGroup}
							</AlertDataRequiredInputs>
						)}
					</div>
				</section>

				<section className='group-form-section'>
					<div className='group-form-section-head'>
						<h2 className='group-form-section-title'>Reglas de pronostico</h2>
						<p className='group-form-section-copy mb-0'>
							Configura el torneo base y la manera en que se asignaran los
							puntos del grupo.
						</p>
					</div>
					<div className='group-form-grid'>
						<div>
							<label htmlFor='typeOfChampionship' className='form-label'>
								Campeonato
							</label>
							{loadingActivesChampionships ? (
								<div className='spinner-border text-dark' role='status'>
									<span className='visually-hidden'>Cargando...</span>
								</div>
							) : (
								<div className='input-group'>
									<select
										className='form-select group-form-input'
										id='typeOfChampionship'
										aria-label='Seleccionar campeonato'
										{...register("leagueIdentifiers.0", {
											required: true,
											onChange: handleOnChangeForm,
										})}
									>
										{!isEditingGroup && <option value=''>Seleccionar...</option>}
										{infoActivesChampionships.Result?.map((item) => (
											<option key={item.uniqueIdentifier} value={item.uniqueIdentifier}>
												{item.name}
											</option>
										))}
									</select>
									{errors.leagueIdentifiers &&
										errors.leagueIdentifiers[0].type === "required" && (
											<AlertDataRequiredInputs>
												{alertRequiredDataDescription.selectingChampionship}
											</AlertDataRequiredInputs>
										)}
								</div>
							)}
						</div>

						<div>
							<label htmlFor='typeOfBet' className='form-label'>
								Tipo de apuesta
							</label>
							{loadingTypesOfBites ? (
								<div className='spinner-border text-dark' role='status'>
									<span className='visually-hidden'>Cargando...</span>
								</div>
							) : (
								<div className='input-group'>
									<select
										disabled={isEditingGroup}
										className='form-select group-form-input'
										id='typeOfBet'
										aria-label='Seleccionar tipo de apuesta'
										{...register("fixtureBetTypeId", {
											required: true,
											onChange: handleOnChangeForm,
										})}
									>
										{!isEditingGroup && <option value=''>Seleccionar...</option>}
										{infoTypesOfBites.Result?.map((item) => (
											<option key={item.id} value={item.id}>
												{item.displayName}
											</option>
										))}
									</select>
									{errors.fixtureBetTypeId?.type === "required" && (
										<AlertDataRequiredInputs>
											{alertRequiredDataDescription.selectingTypeOfBeat}
										</AlertDataRequiredInputs>
									)}
								</div>
							)}
						</div>
					</div>
				</section>

				<section className='group-form-section'>
					<div className='group-form-section-head'>
						<h2 className='group-form-section-title'>Pronosticos de campeonato</h2>
						<p className='group-form-section-copy mb-0'>
							Activa esta opcion solo si quieres sumar apuestas extra para
							campeon y subcampeon.
						</p>
					</div>

					<label
						className={`group-form-toggle ${
							activeLeagueBets ? "is-active" : ""
						}`}
						htmlFor='flexCheckDefault'
					>
						<div>
							<div className='group-form-toggle-title'>
								Habilitar apuestas de campeonato
							</div>
							<div className='group-form-toggle-copy'>
								Define fecha limite y puntajes especiales para este extra.
							</div>
						</div>
						<input
							className='form-check-input'
							type='checkbox'
							id='flexCheckDefault'
							checked={defaultValueToForm.allowLeagueBets}
							value={defaultValueToForm.allowLeagueBets}
							{...register("allowLeagueBets", {
								onChange: handleOnChangeForm,
							})}
						/>
					</label>

					<SettingChampionship
						register={register}
						valueAllowLeagueBets={defaultValueToForm.allowLeagueBets}
						errors={errors}
						alertRequiredDataDescription={alertRequiredDataDescription}
					/>
				</section>

				<div className='group-form-submit-row'>
					<button
						type='submit'
						className='btn btn-primary button-form-create-new-group'
						disabled={loadingCreateNewGroup || loadingEditingGroup}
					>
						{loadingCreateNewGroup || loadingEditingGroup ? (
							<div className='spinner-border text-light' role='status'></div>
						) : (
							<>{isEditingGroup ? "Guardar cambios" : "Crear grupo"}</>
						)}
					</button>
				</div>

				{errors.fixtureBetTypeId?.type === "required" && (
					<AlertCardDataRequired>
						{alertRequiredDataDescription.createGroup}
					</AlertCardDataRequired>
				)}
			</div>

			<aside className='group-form-sidebar'>
				<section className='group-form-summary-card'>
					<p className='group-form-eyebrow mb-2'>Resumen</p>
					<h2 className='group-form-summary-title mb-3'>
						{watchedValues.name || "Tu grupo privado"}
					</h2>
					<div className='group-form-summary-list'>
						<div className='group-form-summary-item'>
							<span className='group-form-summary-label'>Campeonato</span>
							<strong>{selectedChampionshipName}</strong>
						</div>
						<div className='group-form-summary-item'>
							<span className='group-form-summary-label'>Tipo de apuesta</span>
							<strong>{selectedBetTypeName}</strong>
						</div>
						<div className='group-form-summary-item'>
							<span className='group-form-summary-label'>
								Pronosticos de campeonato
							</span>
							<strong>{activeLeagueBets ? "Activos" : "Desactivados"}</strong>
						</div>
						{activeLeagueBets && watchedValues.selectLimitedDateToChampionship && (
							<div className='group-form-summary-item'>
								<span className='group-form-summary-label'>Fecha limite</span>
								<strong>{watchedValues.selectLimitedDateToChampionship}</strong>
							</div>
						)}
					</div>
				</section>

				<section className='group-form-rules-card'>
					<h3 className='group-form-rules-title mb-3'>Vista rapida de reglas</h3>
					<div className='group-form-rule-block'>
						<strong>Ganador</strong>
						<p className='mb-0'>
							Ideal para grupos que quieren una dinamica simple: aciertas el
							ganador o el empate y sumas puntos.
						</p>
					</div>
					<div className='group-form-rule-block'>
						<strong>Marcador</strong>
						<p className='mb-0'>
							Mas competitivo y detallado: premia acertar local, visitante y el
							resultado final del partido.
						</p>
					</div>
					<div className='group-form-rule-block'>
						<strong>Extra de campeonato</strong>
						<p className='mb-0'>
							Activalo si quieres abrir una capa adicional de juego con picks de
							campeon y subcampeon antes de una fecha limite.
						</p>
					</div>
				</section>
			</aside>
		</form>
	);
}

export { FormCreateGroup };
